<template>
  <div class="login">
    <div class="logo">
      <img src="@/assets/img/LOGO.png" alt="" srcset="">
    </div>
    <div class="login-content">
      <div class="login-field-item ponhu-border-1px">
        <div class="login-icon_left">
          <van-icon class-prefix="ph-icon" name="zhanghao" />
        </div>
        <van-field v-model="loginForm.mobile" maxlength="11" placeholder="请输入手机号" @click-right-icon="$toast('question')" />
      </div>
      <div class="login-field-item ponhu-border-1px">
        <van-icon class-prefix="ph-icon" name="mima" />
        <van-field v-model="loginForm.verificationCode" maxlength="6" placeholder="请输入验证码">
          <van-button id="yzm" slot="button" size="small" type="ponhu" :disabled="disabled" @click="getVCode">{{ttext}}</van-button>
        </van-field>
      </div>
    </div>
    <div class="login-question" @click="question">收不到验证码?</div>

    <van-button slot="button" size="large" round type="ponhu" :loading="loading" loading-text="登录中..." @click="submitLogin">登录</van-button>

    <!-- <div class="quickLogin">
      <van-divider>微信登录</van-divider>
      <div class="quickLogin-box">
        <svg-icon icon-class='wx' class-name='wx-icon'></svg-icon>
      </div>
    </div> -->
    <van-action-sheet v-model="custService">
      <service-sheet @close="custService=false"></service-sheet>
    </van-action-sheet>
    <div class="footer-xieyi">
      <img src="https://res.ponhu.cn/redbookRecovery/checkboxSelect.png?a=qweqwe" alt="" v-if="knowType" @click="knowType = !knowType">
      <img src="https://res.ponhu.cn/redbookRecovery/checkboxUncheckedImage2.png?a=qweqwe" alt="" v-else @click="knowType = !knowType">
      我已阅读并同意<a href="https://m.ponhu.cn/Ht/xieyi.html">《用户协议》</a>和<a href="https://m.ponhu.cn/Ht/privacy.html">《胖虎隐私政策》</a>
    </div>
  </div>
</template>
<script>
import service from "./user"
import { sendVCode, quicklyLogin } from '@/api/login'
import { validatMobile } from '@/utils/validate'
import ServiceSheet from '@/components/business/ServiceSheet' 
import { setCookie,getCookie,delCookie } from "@/utils";
export default {
  data () {
    return {
      custService: false,
      return_url: '',
      disabled: false,
      loading: false,
      ttext: '发送验证码',
      loginForm: {
        mobile: '',
        verificationCode: '',
        channel: "2",
        version: ''
      },
      recover_url : process.env.VUE_APP_RECYCLE_URL,
      knowType: false
    }
  },
  components: {
    ServiceSheet
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.return_url = process.env.VUE_APP_ROOT_URL + "index.html#" + from.fullPath;
    })
  },
  created () {
    if(this.$route.query.return_url) {
      this.return_url = decodeURI(this.$route.query.return_url)
    }
     console.log(this.$route.query.return_url)
  },
  methods: {
    question () {
      this.custService = true
    },
    // 获取验证码
    getVCode () {
      if (!validatMobile(this.loginForm.mobile)) {
        this.$toast('请输入正确的手机号')
        return
      }
      let that = this
      let t = 60
      that.ttext = t + '秒后重试'
      that.disabled = true
      var timer = setInterval(function () {
        t--
        if (t > 0) {
          that.ttext = t + '秒后重试'
          that.disabled = true
        } else {
          that.disabled = false
          that.ttext = '获取验证码'
          clearInterval(timer)
        }
      }, 1000)
      console.log(this.loginForm.mobile)
      sendVCode({ mobile: this.loginForm.mobile }).then(res => {console.log(res)}).catch(error => {
        this.$toast(error)
      })
    },
    // 登录
    submitLogin () {
      if (!validatMobile(this.loginForm.mobile)) {
        this.$toast('请输入正确的手机号')
        return
      }
      if (!this.loginForm.verificationCode) {
        this.$toast('请输入短信验证码')
        return
      }
      if (!this.knowType) {
        this.$toast('请先阅读并同意《用户协议》和《胖虎隐私政策》')
        return
      }
      this.loading = true
      // 判断渠道
      var channel = this.$route.query.channel || ''
      var source = this.$route.query.source || ''
      if(channel == 'H5_ai') {
        //this.loginForm.user_source = source;  // 爱回收
        this.loginForm.channel = 22;
        this.return_url = this.recover_url+'index?td_channelid=H5_ai&em='+source
      }
      let inviteCode = this.$route.query.inviteCode
      if (inviteCode) {
        this.loginForm.invitationCode = inviteCode
      }
      quicklyLogin(this.loginForm).then(res => {
        // const token = res.userToken
        // const UserId = res.userId
        // console.log(res.token,res.UserId)
        setCookie('token',res.userToken,60)
        setCookie('userid',res.userId,60)
        this.$store.dispatch('LoginByUser', res.userToken)
        location.href = this.return_url
        this.loading = false
      }).catch(error => {
        this.loading = false
        this.$toast(error)
      })
    }
  }
}
</script>
<style lang='less' scoped>
  .login {
    padding: 100px 75px 0;
    font-size: 28px;
    box-sizing: border-box;
    background: #fff;
    height: 100vh;
    overflow: hidden;
    .logo {
      text-align: center;
      img {
        width: 184px;
        height: 184px;
        margin: 0 auto;
      }
    }
    &-title {
      margin-bottom: 46px;
      padding-left: 24px;
      border-left: 6px solid #FFD133;
    }

    &-content {
      margin-top: 40px;
      .login-field-item {
        margin-bottom: 30px;
        border-radius: 12px;
        border-style: solid;
        border-color: rgba(204, 204, 204, 1);
        padding: 0 5px;
        display: flex;
        align-items: center;
        padding-left: 24px;

        .van-cell {
          padding: 10px;
        }
      }

      .van-button {
        height: 30px !important;
      }
    }

    &-question {
      text-align: right;
      margin-bottom: 46px
    }

    .quickLogin {
      margin-top: 200px;

      &-box {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .wx-icon {
        font-size: 100px;
        color: green
      }
    }
  }
.action-btn {
  width: 100%;
  height: 100%;
  border: 0;
  background-color: transparent;
}
.footer-xieyi {
  position: absolute;
  bottom: 100px;
  font-size: 24px;
  left: 0;
  right: 0;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  a {
    color: rgba(218, 50, 50, 1);
  }
  img {
    width: 28px;
    height: 28px;
    margin-right: 11px;
  }
}
</style>
